import cn from 'classnames'
import { INumberInputProps } from 'legacy/lut/components/common/numberInput/models'
import { NumberInput } from 'legacy/lut/components/common/numberInput/NumberInput'
import { memo } from 'react'

import styles from './PTNumberInput.module.scss'

export const PTNumberInput = memo<INumberInputProps>((props) => {
  const { value, onChange } = props

  return (
    <div className={styles.inputContainer}>
      <NumberInput
        {...props}
        onChange={onChange}
        value={value || '0'}
        classes={{
          ...props.classes,
          inputClasses: {
            ...props.classes?.inputClasses,
            content: cn(props.classes?.inputClasses?.content, styles.inputControl),
          },
        }}
      />
      <span className={styles.inputPostfix}>pt</span>
    </div>
  )
})
